export enum ContractAddressName {
  NftBidOffset = 'NFT_BID_OFFSET',
  NftRedeemV3Stamp = 'NFT_REDEEM_V3_STAMP',
}
